import styled from 'styled-components';
import { baseColors } from '../../../../themes/definitions/si/base-colors';
import { ListTitleCisBox } from './list-title.cis.box';

export const ListTitleSICisBox = styled(ListTitleCisBox)`
    box-shadow: 0px 0px 6px ${baseColors.base08Shadow};
    z-index: 2;
`;
